import React, { useState } from "react";
import Swal from "sweetalert2";

const OtpModal = ({ field, value, onClose, onVerified }) => {
  const [otp, setOtp] = useState("");

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center"
      style={{ zIndex: 1050 }}
    >
      <div className="bg-white rounded shadow p-4" style={{ width: "380px" }}>
        
        <h3 className="fs-5 fw-semibold mb-3">
          Verify {field === "phone" ? "Mobile Number" : "Email"}
        </h3>

        <p className="text-muted mb-2">
          OTP has been sent to <strong>{value}</strong>
        </p>

        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
          className="form-control mb-3"
        />

        <div className="d-flex justify-content-end gap-2">
          <button
            onClick={onClose}
            className="btn btn-secondary"
          >
            Cancel
          </button>

          <button
          type="button"
            onClick={() => onVerified(otp)}
            className="btn btn-primary"
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpModal;

